<div class="unauthourized-container">
  <div class="border-0 card d-flex m-auto text-center w-50 shadow-lg">
    <div class="bg-{{getClass}} border-0 card-header py-5 text-light opacity">
      <h1> Unauthorized Access </h1>
    </div>
    <div class="card-body d-flex flex-column justify-content-center">
      <div class="card-title display-4">
        <span> <i class="fa fa-lg fa-exclamation-triangle pr-2 opacity text-{{getClass}}"></i>
          <b> Oops! </b> </span>
      </div>
      <h4 class="pt-5" [innerHTML]="getContent">
      </h4>
    </div>
    <div class="border-0 card-footer text-right">
      <button class="border-0 btn-lg pointer" title="Logout" (click)="logout()"> <i class="fa fa-sign-out pr-1"></i>
        Logout </button>
    </div>
  </div>
</div>